import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router does NOT scroll to top on navigation by default - it was
 * previously landing wherever the previous page's scroll position happened
 * to be (middle of the page, or the bottom), rather than the top, whenever
 * a new page opened. Mount this once inside <Router>, above <Routes>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
